const userErrorMessages = {
  ERROR_REGISTRATION: 'Error. Please try another email.',
  ERROR_LOGIN: 'Error. Invalid email or password. Please try again.',
  AUTH_FAILED: 'Oops, Google authorize failed. Try again using the form.',
  CURRENT_USER_FAILED: 'The link you followed has expired. Please try again',
};

export default userErrorMessages;
